import { render, staticRenderFns } from "./metaList.vue?vue&type=template&id=05fb910d&scoped=true&"
import script from "./metaList.vue?vue&type=script&lang=js&"
export * from "./metaList.vue?vue&type=script&lang=js&"
import style0 from "./metaList.vue?vue&type=style&index=0&id=05fb910d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb910d",
  null
  
)

export default component.exports